import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';

export default class Notes extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {text, handleInputChange, disabled} = this.props;
    const modules = disabled ?
      {
        toolbar: false
      }
      :
      {
        toolbar: [
          [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
          [{size: []}],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'},
            {'indent': '-1'}, {'indent': '+1'}],
          ['link'],
          ['clean']
        ]
      };

    return (
      <ReactQuill
        className='_margin_top_20'
        readOnly={disabled}
        value={text}
        onChange={handleInputChange}
        theme='snow'
        modules={modules}
      />
    )
  }
}

Notes.propTypes = {
  text: PropTypes.string,
  handleInputChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Notes.defaultProps = {
  text: '',
  handleInputChange: () => {},
  disabled: false,
};



// WEBPACK FOOTER //
// ./src/app/Components/Notes.jsx